import axios from 'axios';

import { toApiDateTime } from '../utils/dateUtils';

const API_URL = process.env.REACT_APP_API_URL;

const getAllocations = async ({ labourerId, projectId, page, perPage }) => {
  const params = {};

  if (labourerId) params.labourerId = labourerId;
  if (projectId) params.projectId = projectId;
  if (page) params.page = page;
  if (perPage) params.perPage = perPage;

  const { data } = await axios.get(`${API_URL}/allocations`, {
    params
  });

  return data;
};

const allocateLabourer = async ({ labourerId, projectId, startDate, endDate }) => {
  const { data } = await axios.post(`${API_URL}/allocations`, {
    labourerId,
    projectId,
    startDate: toApiDateTime(startDate),
    endDate: toApiDateTime(endDate)
  });

  return data;
};

const deleteAllocation = async (allocationId) => {
  await axios.delete(`${API_URL}/allocations/${allocationId}`);
};

const allocationService = {
  getAllocations,
  allocateLabourer,
  deleteAllocation
};

export default allocationService;
